import React, { useMemo } from 'react';
import { MeshProps } from '@react-three/fiber/dist/declarations/src/three-types';
import { Color, MathUtils } from 'three';
import DottedDiskMaterial from '../materials/DottedDiskMaterial';

export type DottedDiskProps = MeshProps & {
    outline?: number,
    color?: number,
    alpha?: number,
    numDots?: number,
    thickness: number,
    children?: React.ReactNode
};

const c = new Color();

export default function DottedDisk({
  outline,
  color,
  children,
  alpha,
  thickness,
  numDots,
  ...props
}: DottedDiskProps): JSX.Element
{
  const _color = useMemo(() =>
  {
    c.set(color || 0x000000);
    const a = alpha || 1;
    if (a < 1) {
      c.r = MathUtils.lerp(1.0, c.r, a);
      c.g = MathUtils.lerp(1.0, c.g, a);
      c.b = MathUtils.lerp(1.0, c.b, a);
    }
    return c.getHex();
  }, [ color, alpha ]);

  return (<mesh {...props} renderOrder={-500}>
    <torusBufferGeometry args={[ 1.0 - thickness * 5, thickness, 8, 32 ]} attach="geometry"/>
    <DottedDiskMaterial color={_color} outline={outline} numDots={numDots}/>
    {children}
  </mesh>);
}
